/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class SourceGrid extends SiteEntityGrid<SourceRow, any> {
        protected getColumnsKey() { return 'Data.Source'; }
        protected getDialogType() { return SourceDialog; }
        protected getIdProperty() { return SourceRow.idProperty; }
        protected getLocalTextPrefix() { return SourceRow.localTextPrefix; }
        protected getService() { return SourceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}